import { buildChallengePath } from '@repo/config';
import { Link } from '@repo/web-chrome/components/link';

interface IChallengeCardProps {
  slug: string;
  title: string;
  cefrLevel?: string;
  definition?: string | null;
  videoCount?: number;
}

export function ChallengeCard({
  slug,
  title,
  cefrLevel,
  definition,
  videoCount,
}: IChallengeCardProps): React.JSX.Element {
  return (
    <Link
      href={buildChallengePath(slug)}
      dir="auto"
      className="cm-lift group flex flex-col gap-1 rounded-xl border border-border bg-card p-4 hover:border-foreground/20 hover:shadow-lg"
    >
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-sm font-semibold text-foreground group-hover:underline">{title}</h3>
        {cefrLevel && (
          <span className="shrink-0 rounded-full bg-muted px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-muted-foreground">
            {cefrLevel}
          </span>
        )}
      </div>
      {definition && (
        <p className="text-xs text-muted-foreground line-clamp-2 leading-relaxed">{definition}</p>
      )}
      {videoCount !== undefined && videoCount > 0 && (
        <p className="mt-1 text-[10px] text-muted-foreground">
          {videoCount} clip{videoCount === 1 ? '' : 's'}
        </p>
      )}
    </Link>
  );
}
